/**
 * Check if the app is running in dev mode.
 * Dev mode is active when either:
 * - NODE_ENV is not production (local dev server)
 * - REACT_APP_DEV_MODE is set to "true" (hosted dev build)
 */
export const isDevMode = () => {
  return process.env.NODE_ENV !== "production" || process.env.REACT_APP_DEV_MODE === "true";
};
